import React, { useEffect } from 'react';
import { 
  ThemeProvider, 
  CssBaseline,
  Box,
  Container
} from '@material-ui/core';
import { Box as AWSUIBox, Container as AWSUIContainer } from '@amzn/awsui-components-react-v3';
import { websiteViewTheme } from './styles/theme';
import { useAppLayoutStyles } from './styles/app-layout.styles';
import { WebsiteSelector } from './selector';
import { WebsiteMetadata } from './metadata';
import { PrimitiveMetrics } from './primitive-metrics';
import { TimelineView } from './timeline-view';
import { WebsiteSummary } from './website-summary';
import { metricFeaturesList, metricPageNames } from 'src/constants/swo-ui-metric-constants';
import { SwoUiMetrics } from 'src/utils/swo-ui-metrics/swo-ui-metrics';

export const WebsiteViewLayout = React.memo(() => {
    const classes = useAppLayoutStyles();
    
    useEffect(() => {
        SwoUiMetrics.publishCloudWatchCountMetric(metricPageNames.websiteView, metricFeaturesList.websiteAnalysisAndDiagnosticTool);
    }, [])

    return (
        <ThemeProvider theme={websiteViewTheme}>
            <CssBaseline />            
            <AWSUIBox  padding={{vertical: "xs", horizontal: "xl"}}>
                <AWSUIContainer header={
                    <AWSUIBox variant="h2" padding={{ top: "m" }}>
                    Website Flow Analysis & Diagnostic Tool
                </AWSUIBox>
                }>
                    <WebsiteSelector />
                </AWSUIContainer>
            </AWSUIBox>
            <Box className={classes.root}>
                {/* Main Content */}
                <Box
                    component="main"
                    className={classes.mainContent}
                >
                    <Container maxWidth={false} className={classes.container}>
                        <Box className={classes.cardContainer}>
                            <WebsiteSummary />
                        </Box>

                        {/* Timeline Section - Full Width */}
                        {<Box className={classes.timelineSection}>
                            <TimelineView />
                        </Box>}

                        {/* EWC Metadata Section */}
                        <Box className={classes.cardContainer}>
                            <WebsiteMetadata />
                        </Box>

                        {/* Primitive Metrics Section - Full Width */}
                        <Box className={classes.cardContainer}>
                            <PrimitiveMetrics />
                        </Box>
                        
                    </Container>
                </Box>
            </Box>
        </ThemeProvider>
    );
});

WebsiteViewLayout.displayName = 'WebsiteViewLayout';
